import React from "react";
import {findDOMNode} from "react-dom";

import PopoverAddColumn from "../../../../../../gd-modules/common/add-column-new/popover/popover";
import Popover from "../../../../../../gd-components/gd-popover/popover";
import FieldSelectField from "../../select-field";
import convertFieldsStructureToConfig from "../../../../../../gd-modules/common/add-column-new/convert-fields-structure";

export default function FieldSelectField_Popover(props:any) {

    const onSelect = (value:fieldId) => {
        props.parent.hidePopover();
        props.parent.onValueChange(value);
    };

    const field : FieldSelectField = props.field

    const manageColumnsConfig = convertFieldsStructureToConfig(field.fieldsStructure, props.model?.restrictedFields)
    const value = props.field.getViewValue(props.model)

    return (
        <Popover popoverClass       = "gd-popover-add-column-new h-300"
                 attachment         = {props.options?.attachment}
                 targetAttachment   = {props.options?.targetAttachment}
                 onClickOutside     = {()=>{props.parent.hidePopover()}}
                 getTargetFunc      = {()=>findDOMNode(props.parent)}

        >
            <PopoverAddColumn manageColumnsConfig   = {manageColumnsConfig}
                              fields                = {field.fields.models}
                              columns               = {[{fieldId: value}]}
                              mandatoryColumnsIds   = {[]}
                              noValueOption         = {field.noValueOption ? {icon: field.noValueOptionIcon, label: field.noValueOptionLabel} : undefined}
                              showAdd               = {false}
                              hidePopover           = {props.parent.hidePopover}
                              onToggleColumn        = {onSelect}

                // onAddCustomField={this.onAddCustomField}
                              onNewCustomField={()=>{}}
            />
        </Popover>
    );
}